import { Directive, HostListener, ElementRef, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[dateFormat]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateFormatDirective),
      multi: true,
    },
  ],
})
export class DateFormatDirective implements ControlValueAccessor {
  private onChange!: (value: Date | null) => void;
  private onTouched!: () => void;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  writeValue(value: Date | null): void {
    this.el.nativeElement.value = value ? this.formatDate(value) : '';
  }

  registerOnChange(fn: (value: Date | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const parsed = this.parseDate(value);
    this.onChange(parsed);
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }

  private formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  private parseDate(value: string): Date | null {
    const parts = value.split('/');
    if (parts.length !== 3) return null;
    const [day, month, year] = parts.map(Number);
    const result = new Date(year, month - 1, day);
    return isNaN(result.getTime()) ? null : result;
  }
}
